/**
 * Query key utilities for support hooks
 * Keys match backend controller method names
 */
export const supportKeys = {
  contactSupport: () => ["support", "contactSupport"] as const,
} as const
